// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-top {
  padding: 15px;
  box-shadow: 0px 2px 6px #e7e7e7;
  position: fixed;
  width: 100%;
  top: 0;
  background: #fff;
  z-index: 2;
}

.my-element + .left-scroll-menu .offcanvas-header{
  padding: 20px;
  background: #333547;
}

.my-element+.left-scroll-menu{
  position: absolute;
  left: 0;
  top: 0;
  background-color: #333547;
  color: #b4c9de;
  transform: translateX(-100%);
  transition: all .4s;
  height: 100%;
  width: 80%;
  z-index: 1;
}

.my-element+.left-scroll-menu ul li svg{
  min-width: 19px;
}
.min-width-100{
  min-width:100px;
}
.min-width-80{
  min-width:80px;
}
.font-size-12{
  font-size: 12px;
}
.my-element.active+.left-scroll-menu{
  transform: translateX(0);
}

ul, li{
  list-style: none;
}

.left-scroll-menu ul{
  margin: 0px 0;
  padding: 0;
  background-color: #383b4e;
}

.left-scroll-menu ul li{
  padding: 12.5px 20px;
  border-bottom: 1px solid #434557;
}

.left-scroll-menu ul li.mm-active {
  color: #b4c9de !important;
  background-color: #383b4e;
}

.left-scroll-menu ul li a{
  color:#b4c9de;
  text-decoration: none;
  margin-left: 7px;
}


.drop-menu{
  display: none;
}

.my-element2.active + .drop-menu{
  display: block;
  position: absolute;
  top: 60px;
  right: 15px;
  background: #fff;
  padding: 0 0;
  box-shadow: 0px 0px 4px #d5d5d5;
  border-radius: 4px;
  min-width: 100px;
  width: auto;
}

.my-element2.active + .drop-menu ul{
  padding: 0 0;
  margin-bottom: 0;
}

.my-element2.active + .drop-menu ul li{
  padding: 5px 10px;
  border-bottom: 1px solid #f1f1f1;
}

.my-element2.active + .drop-menu ul li a{
  text-decoration: none;
  color: #717171;
}

.three-dot.my-element2.active + .drop-menu{
  /* padding-bottom: 60px; */
}

.top-header-notification{
  position: absolute;
  top: -4px;
  right: 10px;
  /* background: #c30000; */
  border-radius: 50%;
  height: 15px;
  width: 15px;
  text-align: center;
  line-height: 15px;
  color: #fff;
  font-size: 10px;
}

.app-top-right a{
  color: #333547;
}

.app-top .profile-img{
  width: 40px;
  height: 40px;
  margin-left: 10px;
  overflow: inherit;
}

.app-top .profile-img img{
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/components/AppTop.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,+BAA+B;EAC/B,eAAe;EACf,WAAW;EACX,MAAM;EACN,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,yBAAyB;EACzB,cAAc;EACd,4BAA4B;EAC5B,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".app-top {\r\n  padding: 15px;\r\n  box-shadow: 0px 2px 6px #e7e7e7;\r\n  position: fixed;\r\n  width: 100%;\r\n  top: 0;\r\n  background: #fff;\r\n  z-index: 2;\r\n}\r\n\r\n.my-element + .left-scroll-menu .offcanvas-header{\r\n  padding: 20px;\r\n  background: #333547;\r\n}\r\n\r\n.my-element+.left-scroll-menu{\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  background-color: #333547;\r\n  color: #b4c9de;\r\n  transform: translateX(-100%);\r\n  transition: all .4s;\r\n  height: 100%;\r\n  width: 80%;\r\n  z-index: 1;\r\n}\r\n\r\n.my-element+.left-scroll-menu ul li svg{\r\n  min-width: 19px;\r\n}\r\n.min-width-100{\r\n  min-width:100px;\r\n}\r\n.min-width-80{\r\n  min-width:80px;\r\n}\r\n.font-size-12{\r\n  font-size: 12px;\r\n}\r\n.my-element.active+.left-scroll-menu{\r\n  transform: translateX(0);\r\n}\r\n\r\nul, li{\r\n  list-style: none;\r\n}\r\n\r\n.left-scroll-menu ul{\r\n  margin: 0px 0;\r\n  padding: 0;\r\n  background-color: #383b4e;\r\n}\r\n\r\n.left-scroll-menu ul li{\r\n  padding: 12.5px 20px;\r\n  border-bottom: 1px solid #434557;\r\n}\r\n\r\n.left-scroll-menu ul li.mm-active {\r\n  color: #b4c9de !important;\r\n  background-color: #383b4e;\r\n}\r\n\r\n.left-scroll-menu ul li a{\r\n  color:#b4c9de;\r\n  text-decoration: none;\r\n  margin-left: 7px;\r\n}\r\n\r\n\r\n.drop-menu{\r\n  display: none;\r\n}\r\n\r\n.my-element2.active + .drop-menu{\r\n  display: block;\r\n  position: absolute;\r\n  top: 60px;\r\n  right: 15px;\r\n  background: #fff;\r\n  padding: 0 0;\r\n  box-shadow: 0px 0px 4px #d5d5d5;\r\n  border-radius: 4px;\r\n  min-width: 100px;\r\n  width: auto;\r\n}\r\n\r\n.my-element2.active + .drop-menu ul{\r\n  padding: 0 0;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.my-element2.active + .drop-menu ul li{\r\n  padding: 5px 10px;\r\n  border-bottom: 1px solid #f1f1f1;\r\n}\r\n\r\n.my-element2.active + .drop-menu ul li a{\r\n  text-decoration: none;\r\n  color: #717171;\r\n}\r\n\r\n.three-dot.my-element2.active + .drop-menu{\r\n  /* padding-bottom: 60px; */\r\n}\r\n\r\n.top-header-notification{\r\n  position: absolute;\r\n  top: -4px;\r\n  right: 10px;\r\n  /* background: #c30000; */\r\n  border-radius: 50%;\r\n  height: 15px;\r\n  width: 15px;\r\n  text-align: center;\r\n  line-height: 15px;\r\n  color: #fff;\r\n  font-size: 10px;\r\n}\r\n\r\n.app-top-right a{\r\n  color: #333547;\r\n}\r\n\r\n.app-top .profile-img{\r\n  width: 40px;\r\n  height: 40px;\r\n  margin-left: 10px;\r\n  overflow: inherit;\r\n}\r\n\r\n.app-top .profile-img img{\r\n  border-radius: 50%;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
